import { Button, Divider, Dropdown, Menu } from 'antd';
import React from 'react'
import { FaPhone, FaPhoneVolume, FaPowerOff, FaRegUser } from "react-icons/fa6";
import { RiLockPasswordLine } from "react-icons/ri";
import { FaUserCircle } from "react-icons/fa";
import { DownOutlined } from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";

const CallAgentHeader = () => {
    const menu = (
        <Menu className="dark:bg-primary_color dark:text-white w-56 ">
            {/* <Menu.Item
            className="py-2 dark:text-white dark:hover:bg-primary_color dark:bg-primary_color hover:bg-gray-300 dark:hover:text-blueGray-500"
            key="/profile"
            icon={<FaRegUser className="inline mr-4" />}
          >
            <Link to="/profile">Profile</Link>
          </Menu.Item>
    
          <Divider className="my-1" /> */}

            <Menu.Item
                onClick={() => {
                    history.push("/call-center/change_password");
                }}
                key="23"
                className="pt-2 dark:text-white dark:hover:bg-primary_color dark:bg-primary_color  hover:bg-gray-300 dark:hover:text-blueGray-500"
                icon={<RiLockPasswordLine className="inline mr-4" />}
            >
                Change Password
            </Menu.Item>

            <Divider className="my-3 " />

            <Menu.Item
                onClick={() => {
                    localStorage.removeItem("user");
                    history.push("/login");
                }}
                key="24"
                className="pb-4 dark:text-white dark:hover:bg-primary_color dark:bg-primary_color hover:bg-gray-300 dark:hover:text-blueGray-500"
                icon={<FaPowerOff className="inline mr-4" />}
            >
                Log Out
            </Menu.Item>
        </Menu>
    );

    const usrObj = JSON.parse(localStorage.getItem("user"));
    const user = usrObj?.user;
    const history = useHistory();
    return (
        <div><div
            className={`dark:bg-primary_color relative w-full px-4 sm:px-6 bg-gradient-to-l border-b mb-5`}
        >
            <div className="flex justify-between items-center  py-6 md:justify-start md:space-x-10">
                <div className="flex items-center justify-start lg:w-0 lg:flex-1">
                    <a href="/"></a>{" "}
                    <span className="text-primary_color dark:text-white text-xl uppercase ml-4 font-bold">
                        YEGNATELE
                    </span>
                </div>

                <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0">
                    <Dropdown overlay={menu} trigger={["click"]}>
                        <Button
                            type="text"
                            className="flex focus:border-primary_color dark:border-primary_color items-center justify-between dark:focus:border-white focus:border whitespace-nowrap text-base font-medium text-primary_color dark:text-white hover:text-blueGray-500 dark:hover:text-blueGray-300"
                        >
                            <FaUserCircle className="text-2xl ml-4 pr-2" />
                            <span className="capitalize">{user.name}</span>
                            <DownOutlined className="pl-2" />
                        </Button>
                    </Dropdown>
                </div>
            </div>
        </div></div>
    )
}

export default CallAgentHeader